import { Flex } from "@otrium/core";
import styled from "@emotion/styled";

const CartItemContainer = styled(Flex)`
  border-top: solid 1px ${({ theme }) => theme.colors.primary.platinumLight};

  &:last-of-type {
    border-bottom: solid 1px
      ${({ theme }) => theme.colors.primary.platinumLight};
  }
`;

const CartItemContent = styled(Flex)<{
  isDisabled?: boolean;
}>`
  flex-direction: column;
  color: ${({ theme }) => theme.colors.tone.anthraciteLight};
  padding: ${({ theme }) => theme.space[3]}px;
  position: relative;

  ${({ isDisabled, theme }) =>
    isDisabled &&
    `
  border-color: ${theme.colors.tone.marble};

  &:before {
    width: 100%;
    height: 100%;
    content: '';
    position: absolute;
    bottom: 0;
    right: 0;
    top: 0;
    left: 0;
    z-index: 1;
    opacity: 0.67;
    background-color: ${theme.colors.tone.sand};
  }
  `}
`;

export { CartItemContainer, CartItemContent };
